/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'search': {
    width: 18,
    height: 18,
    viewBox: '0 0 18 18',
    data: '<path pid="0" d="M12.5 11l4.99 5L16 17.49l-5-4.99v-.79l-.27-.28A6.471 6.471 0 0 1 6.5 13 6.5 6.5 0 1 1 13 6.5c0 1.61-.59 3.09-1.57 4.23l.28.27h.79zm-6 0C8.99 11 11 8.99 11 6.5S8.99 2 6.5 2 2 4.01 2 6.5 4.01 11 6.5 11z" _fill="#000" fill-rule="nonzero"/>'
  }
})



// WEBPACK FOOTER //
// ./src/components/icons/search.js